<template lang="pug">
v-list.factsheet.pt-4(subheader)
	v-list-item.px-0(v-for="fact in facts" dense v-if="fact.value" :key="fact.label")
		v-list-item-avatar.mr-2
			ws-icon {{fact.icon}}
		v-list-item-content.py-2
			v-list-item-title.caption.font-weight-bold {{fact.label}}
			v-list-item-subtitle.caption.black--text {{fact.display ? fact.display : fact.value}}

	template(v-if="['nl-NL', 'nl-BE'].includes($i18n.locale)")
		v-divider.mx-4.mt-3(v-if="accommodations || skischools || rentals")
		v-list-item.px-0.mb-n4(v-if="accommodations")
			v-list-item-avatar.mr-2
				ws-icon bed
			v-list-item-content
				v-list-item-title.caption
					nuxt-link.caption(:to="localePath({name: 'resorts-resort-accommodationtype', params: { accommodationtype: $localeSlug('accommodations', $i18n.locale) }})") {{$t('infosheet.facilities.accommodations_{count}', {count: accommodations})}}
		v-list-item.px-0.mb-n4(v-if="skischools")
			v-list-item-avatar.mr-2
				ws-icon ski
			v-list-item-content(style="flex-shrink: 1")
				v-list-item-title.caption
					nuxt-link(:to="localePath({name: 'resorts-resort-lesson' })") {{skischools}} {{$t('infosheet.facilities.skischools')}}
			v-list-item-content(style="flex-grow: 2")
				nuxt-link(:to="localePath({name: 'resorts-resort-lesson' })")
					v-img(src="https://cdn.wintersport.nl/media/partners/2020/10/05/Partner_logo_checkyeti_(320x106px).jpg" width="70" height="24" contain)
		v-list-item.px-0.mb-n4(v-if="rentals")
			v-list-item-avatar.mr-2
				v-icon store
			v-list-item-content
				v-list-item-title.caption
					nuxt-link.caption(:to="localePath({name: 'resorts-resort-rental', })") {{rentals}} {{$t('infosheet.facilities.rentals')}}

</template>

<style lang="sass">
.localdestination--factsheet
  td
    border: none !important
  tr:hover
    background: none !important
</style>

<script>
export default {
	props: {
		facts: {
			type: Array,
			default: () => []
		},
		accommodations: {
			type: Number,
			default: 0
		},
		skischools: {
			type: Number,
			default: 0
		},
		rentals: {
			type: Number,
			default: 0
		}
	}
};
</script>
